import React from 'react';

import { TextComponent } from 'design/text/textComponents';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { PressControlComponent } from 'design/pressControl';
import { AuthorizeWithGoogleButton } from 'containers/AuthorizeWithGoogleButton';
import { MarginComponent } from 'design/margin';
import { DelimiterComponent } from 'design/delimiter';
import { ImplicitAuthTarget } from 'types/implicitAuthTypes';
import { routes } from 'utils/routes';
import { MessageIcon } from 'svg/24x24/message';
import { AuthFormFooterLayoutComponent } from 'design/authFormFooterLayout/authFormFooterLayoutComponents';
import { MobileAppReferer } from 'utils/MobileAppReferer';

type Props = {
  onEmailProviderSelected(): void;
  target?: ImplicitAuthTarget;
};

export const ImplicitAuthProviderForm = (props: Props) => {
  const { onEmailProviderSelected: selectEmailProvider, target } = props;

  const { implicitAuthForm: ownDictionary } = useIntlDictionary();

  const redirectTo = React.useMemo(() => {
    switch (target) {
      case 'DEMO':
        return routes.registrationDemo();
      case 'PROD': {
        // Проверка, пришел ли пользователь из мобильного приложения
        // для добавления соответствующих параметров отслеживания
        const referedFromMobileApp = MobileAppReferer.isCurrentSessionReferedFromMobileApp();

        if (referedFromMobileApp) {
          const pathName = routes.registrationProd();

          const searchParams = MobileAppReferer.createMobileAppRefererQueryString();

          return `${pathName}?${searchParams}`;
        }

        return routes.registrationProd();
      }
      case 'PARTNER':
        return routes.registrationPartner();
      default:
        return '/';
    }
  }, [target]);

  const topTextNode = React.useMemo(() => {
    switch (target) {
      case 'DEMO':
        return ownDictionary.demoAgreementText();
      default:
        return null;
    }
  }, [ownDictionary, target]);

  return (
    <>
      {topTextNode && (
        <>
          {topTextNode}
          <MarginComponent top={44} />
        </>
      )}
      <AuthFormFooterLayoutComponent>
        <PressControlComponent
          theme="primary"
          type="button"
          hasIcon
          onPress={selectEmailProvider}
        >
          <MessageIcon />
          <TextComponent color="inherit">
            {ownDictionary.selectEmailProviderActionText}
          </TextComponent>
        </PressControlComponent>
        <MarginComponent top={24} bottom={24}>
          <DelimiterComponent>
            <TextComponent color="secondary">
              {ownDictionary.delimiterText}
            </TextComponent>
          </DelimiterComponent>
        </MarginComponent>
        <AuthorizeWithGoogleButton redirectOnSucceedTo={redirectTo} />
      </AuthFormFooterLayoutComponent>
    </>
  );
};
